import React from "react";
import SetupStepTitle from "./SetupStepTitle";
const EarningsDescription = props => {
  return (
    <div className="entity-page-content col-lg-9 col-md-8">
      <SetupStepTitle stepNumber={1} title="Description" />
      <div className="seperator" style={{ marginTop: "20px" }}>
        <hr />
      </div>
      <div className="description-content">{props.children}</div>
    </div>
  );
};
export default EarningsDescription;
